import { Box } from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';

import { useGetWebhookSubscriptionsForUserQuery } from '../requests/webhooks.gql.generated';

export const WebhooksIntegrationView = () => {
  const { data: webhookData } = useGetWebhookSubscriptionsForUserQuery();
  if (!webhookData || !webhookData.webhookSubscriptionsForUser) {
    return <></>;
  }
  const { webhookSubscriptionsForUser } = webhookData;
  if (webhookSubscriptionsForUser.length === 0) {
    return (
      <Box>
        If you would like to integrate a webhook, please contact
        support@finleycms.com
      </Box>
    );
  }

  const SvixContainers = _.map(
    webhookSubscriptionsForUser,
    (webhookSubscription) => {
      return (
        <Box
          key={`webhook-subscription-${webhookSubscription.svixApplicationId}`}
          mb="15px"
        >
          <iframe
            title="svix-iframe"
            src={webhookSubscription.svixDashboardUrl}
            style={{
              width: '100%',
              height: '650px',
              border: 'none',
            }}
            allow="clipboard-write"
            loading="lazy"
          />
        </Box>
      );
    },
  );
  return <Box>{SvixContainers}</Box>;
};
